/*eslint no-useless-computed-key: "off"*/
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import { withRouter, useParams } from "react-router-dom";
// import ReactPixel from "react-facebook-pixel";
import ReactLoading from "react-loading";

import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Hidden from "@material-ui/core/Hidden";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import PayPalButton from "componentsCustom/Cart/PayPalButton.js";
// import GooglePayButton from "componentsCustom/Cart/GooglePayButton.js";
import CashPayButton from "componentsCustom/Cart/CashPayButton.js";
import MealVoucherButton from "componentsCustom/Cart/MealVoucherButton.js";
import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";

import config from "config/config.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";

import { calculateValueCurrency } from "util/calculation";
import styles from "./Payment.module.css";
import SidebarCart from "../container/view/SidebarCartContainer";

const useStyles = makeStyles(shippingAddressStyle);

function Payment(props) {
  const [loaderCreation, setLoaderCreation] = useState(false);

  const [checked, setChecked] = useState(false);

  const [response, setResponse] = useState("");

  const { home } = useParams();

  const {
    cart,
    shippingInfo,
    museum,
    history,
    language,
    currency,
    updateReservations,
    customStyle,
    cartParams,
    cartUnique,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    totalPriceEuro,
    servicesFeesEuro,
    deliveryCostEuro,
    totToShowEuro,
    vatEuro,
  } = cartParams;

  function paymentResponse(response, type) {
    setLoaderCreation(false);
    if (
      (type === "SUCCESS" || type === "SUCCESS_CASH") &&
      response &&
      response.message === "OK"
    ) {
      // FAI LA NAVIGAZIONE ALLA THANK YOU PAGE
      //We cannot simply push the path as we have the home page as last parameter of the URL
      var url = history.location.pathname;
      url = url.slice(0, url.lastIndexOf("/"));
      url = url.slice(0, url.lastIndexOf("/")) + "/thank-you/" + home;

      history.replace(url);
    }
    if (type === "ERROR") {
      setResponse({
        status: "ERROR",
        title: t("payment.error_title"),
        description: t("payment.error_description"),
        onSuccess: () => {
          var url = history.location.pathname;
          url = url.slice(0, url.lastIndexOf("/"));
          url = url.slice(0, url.lastIndexOf("/")) + "/shop/" + home;

          history.replace(url);
        },
      });
    }
  }

  let isPayPalAccepted = true;
  let isCashAccepted = false;
  let mealVoucherArray = [];

  if (
    museum &&
    museum.delivery &&
    museum.delivery.paymentAccepted &&
    Array.isArray(museum.delivery.paymentAccepted) &&
    museum.delivery.paymentAccepted.length > 0
  ) {
    isPayPalAccepted = !!museum.delivery.paymentAccepted.find(
      (el) => el.label === "Paypal"
    );
    isCashAccepted = !!museum.delivery.paymentAccepted.find(
      (el) => el.label === "Cash"
    );
    mealVoucherArray = museum.delivery.paymentAccepted.filter(
      (el) => el.type === "food_stamps"
    );
  }

  const componentsContent = (
    <div className={classes.container}>
      {loaderCreation ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "100px",
          }}
        >
          <ReactLoading
            type={"spinningBubbles"}
            color={"black"}
            height={50}
            width={50}
          />
        </div>
      ) : (
        <Card className={classes.card}>
          <CardBody>
            <Button
              round
              size="sm"
              color="transparent"
              className={classes.buttonBack}
              // style={styles.backSweetAlertStyle}
              onClick={() => {
                var url = history.location.pathname;
                url = url.slice(0, url.lastIndexOf("/"));
                url =
                  url.slice(0, url.lastIndexOf("/")) + "/information/" + home;

                history.replace(url);
              }}
            >
              <span
                className={classes.buttonText}
                style={{ fontSize: "11px", paddingLeft: "6px" }}
              >
                <ArrowBackIosIcon style={{ marginRight: 0 }} />
              </span>
            </Button>
            <CardHeader>
              <h1 className={classes.title}>{t("payment.title")}</h1>
            </CardHeader>
            <CardBody style={{ zIndex: 1 }}>
              <GridContainer
                direction="column"
                justifyContent="stretch"
                alignItems="center"
              >
                {isPayPalAccepted && totToShowEuro > 0 ? (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ minWidth: "300px" }}
                    // style={{ margin: "5px 10px" }}
                  >
                    <h4 className={styles.paymentTitle}>
                      {t("payment.payWithPayPalOrCreditCard")}
                    </h4>
                    <PayPalButton
                      // env={config.paypal.env}
                      language={language}
                      env="production"
                      sandboxID={config.paypal.sandboxID}
                      productionID={
                        museum && museum.paypalId
                          ? museum.paypalId
                          : config.paypal.sandboxID
                      }
                      currency="EUR"
                      updateReservations={updateReservations}
                      cart={cart}
                      vat={Number(vatEuro.toFixed(2))}
                      commit
                      shippingInfo={shippingInfo}
                      museumId={museum && museum._id}
                      museum={museum}
                      active={
                        !!(checked && cart && cart.length > 0 && museum && true)
                      }
                      paymentResponse={paymentResponse}
                      // COSTS
                      totalPrice={Number(totToShowEuro.toFixed(2))}
                      deliveryPrice={Number(deliveryCostEuro.toFixed(2))}
                      servicePrice={Number(servicesFeesEuro.toFixed(2))}
                      subPrice={Number(totalPriceEuro.toFixed(2))}
                      minTotal={
                        museum && museum.delivery && museum.delivery.minTotal
                      }
                      //
                      cartUnique={cartUnique}
                      enableLoading={() => setLoaderCreation(true)}
                    />
                  </GridItem>
                ) : (
                  !isPayPalAccepted && (
                    <ReactLoading
                      type={"spinningBubbles"}
                      color={"black"}
                      height={50}
                      width={50}
                    />
                  )
                )}
                {isCashAccepted && totToShowEuro > 0 ? (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ minWidth: "300px" }}
                  >
                    <h4 className={styles.paymentTitle}>
                      {t("payment.payInBoxOffice")}
                    </h4>
                    <CashPayButton
                      env={config.paypal.env}
                      language={language}
                      // env="production"
                      currency="EUR"
                      cart={cart}
                      updateReservations={updateReservations}
                      vat={Number(vatEuro.toFixed(2))}
                      shippingInfo={shippingInfo}
                      museumId={museum && museum._id}
                      museum={museum}
                      active={
                        !!(checked && cart && cart.length > 0 && museum && true)
                      }
                      paymentResponse={paymentResponse}
                      customStyle={customStyle}
                      // COSTS
                      totalPrice={Number(totToShowEuro.toFixed(2))}
                      deliveryPrice={Number(deliveryCostEuro.toFixed(2))}
                      servicePrice={Number(servicesFeesEuro.toFixed(2))}
                      subPrice={Number(totalPriceEuro.toFixed(2))}
                      minTotal={
                        museum && museum.delivery && museum.delivery.minTotal
                      }
                      showPopup={false}
                      //
                      cartUnique={cartUnique}
                      enableLoading={() => setLoaderCreation(true)}
                    />
                  </GridItem>
                ) : null}
                {totToShowEuro === 0 ? (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ minWidth: "300px" }}
                  >
                    <CashPayButton
                      env={config.paypal.env}
                      language={language}
                      freeTickets
                      // env="production"
                      currency="EUR"
                      cart={cart}
                      updateReservations={updateReservations}
                      vat={Number(vatEuro.toFixed(2))}
                      shippingInfo={shippingInfo}
                      museumId={museum && museum._id}
                      museum={museum}
                      active={
                        !!(checked && cart && cart.length > 0 && museum && true)
                      }
                      paymentResponse={paymentResponse}
                      customStyle={customStyle}
                      // COSTS
                      totalPrice={Number(totToShowEuro.toFixed(2))}
                      deliveryPrice={Number(deliveryCostEuro.toFixed(2))}
                      servicePrice={Number(servicesFeesEuro.toFixed(2))}
                      subPrice={Number(totalPriceEuro.toFixed(2))}
                      minTotal={
                        museum && museum.delivery && museum.delivery.minTotal
                      }
                      showPopup={false}
                      //
                      cartUnique={cartUnique}
                      enableLoading={() => setLoaderCreation(true)}
                    />
                  </GridItem>
                ) : null}
                {mealVoucherArray && mealVoucherArray.length > 0 ? (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ minWidth: "300px" }}
                  >
                    <MealVoucherButton
                      env={config.paypal.env}
                      language={language}
                      // env="production"
                      currency="EUR"
                      cart={cart}
                      vat={Number(vatEuro.toFixed(2))}
                      shippingInfo={shippingInfo}
                      museumId={museum && museum._id}
                      museum={museum}
                      active={
                        !!(
                          checked &&
                          cart &&
                          cart.length > 0 &&
                          museum &&
                          museum.delivery &&
                          (museum.delivery.minTotal <= totToShowEuro ||
                            !museum.delivery.minTotal)
                        )
                      }
                      paymentResponse={paymentResponse}
                      customStyle={customStyle}
                      mealVoucherArray={mealVoucherArray}
                      // COSTS
                      totalPrice={Number(totToShowEuro.toFixed(2))}
                      deliveryPrice={Number(deliveryCostEuro.toFixed(2))}
                      servicePrice={Number(servicesFeesEuro.toFixed(2))}
                      subPrice={Number(totalPriceEuro.toFixed(2))}
                      minTotal={
                        museum && museum.delivery && museum.delivery.minTotal
                      }
                      showPopup={false}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
              <div className={classes.checkboxAndRadio}>
                {museum &&
                museum.delivery &&
                museum.delivery.minTotal &&
                museum.delivery.clientId &&
                (museum.delivery.minTotal > totToShowEuro ||
                  !museum.delivery.minTotal) ? (
                  <div
                    className={classes.minTotal}
                    style={{ width: "100%", fontSize: "20px", color: "red" }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {t("cart.min_total_title")}
                    </span>
                    <div>
                      <span style={{ fontStyle: "italic" }}>
                        {t("cart.min_total_description")}{" "}
                        {calculateValueCurrency(
                          museum && museum.delivery && museum.delivery.minTotal,
                          currency
                        ).toFixed(2)}
                        {currency.symbol}
                      </span>
                    </div>
                  </div>
                ) : (
                  <>
                    <div>
                      <Checkbox
                        onClick={() => {
                          // museumData.isMultiFloor = !museumData.isMultiFloor;
                          setChecked(!checked);
                        }}
                        color={"default"}
                        checked={checked}
                      />
                    </div>
                    <span style={{ lineHeight: "30px", paddingTop: "6px" }}>
                      {t("payment.agree_terms_and_condition")}{" "}
                      <a
                        href={config.links[language]["privacy_policy"]}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span style={{ color: "#2d5360" }}>
                          {t("payment.privacy_policy")}
                        </span>
                      </a>{" "}
                      {t("payment.and")}{" "}
                      <a
                        href={config.links[language]["terms_and_condition"]}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span style={{ color: "#2d5360" }}>
                          {t("payment.terms_and_condition")}
                        </span>
                      </a>{" "}
                      {t("payment.emma")}
                    </span>
                  </>
                )}
              </div>
            </CardBody>
          </CardBody>
          <Hidden smDown implementation="css">
            <div className={classes.containerButtons}>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ textAlign: "center" }}
                >
                  <Button
                    round
                    size="sm"
                    onClick={() => {
                      var url = history.location.pathname;
                      url = url.slice(0, url.lastIndexOf("/"));
                      url =
                        url.slice(0, url.lastIndexOf("/")) + "/shop/" + home;

                      history.replace(url);
                    }}
                    style={{
                      backgroundColor: customStyle.buttonBackToMenu,
                    }}
                  >
                    <span className={classes.buttonTextNormal}>
                      {t("shippingAddress.back_menu")}
                    </span>
                  </Button>
                </GridItem>
              </GridContainer>
            </div>
          </Hidden>
        </Card>
      )}
    </div>
  );

  return (
    <>
      <MobileWrapper
        type={"payment"}
        customStyle={customStyle}
        showButtons
        buttons={[
          {
            onClick: () => {},
            color: "whiteRed",
            text: t("shippingAddress.back_menu"),
            isActive: true,
            isLinkActive: true,
            path: `../shop`,
            classNameText: classes.buttonBigTextMenu,
            customColor: customStyle.buttonAction,
          },
        ]}
      >
        <div className={styles.sidenavContainer}>
          <SidebarCart showGoToCheckout={false} />
        </div>

        <div className={styles.contentContainer}>
          {/* non posso creare 2 bottoni di paypal ??? */}
          {componentsContent}
          {/* <div className="logo_emma">
            <img src={logo} alt="logo" />
          </div> */}
        </div>
      </MobileWrapper>
      {response ? (
        <SweetAlert
          success={response.status === "SUCCESS"}
          danger={response.status === "ERROR"}
          error={false}
          style={{ display: "block", top: "20%", marginTop: "0px" }}
          title={response.title}
          onConfirm={() => {
            setResponse("");
            response.onSuccess();
          }}
          onCancel={() => {
            setResponse("");
            response.onSuccess();
          }}
          confirmBtnCssClass={classes.button + " " + classes.success}
        >
          {response.description}
        </SweetAlert>
      ) : null}
    </>
  );
}

Payment.propTypes = {
  language: PropTypes.string.isRequired,
  museum: PropTypes.object.isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  shippingInfo: PropTypes.shape({
    prefix: PropTypes.string,
    telephone: PropTypes.string,
    date: PropTypes.any,
    time: PropTypes.string,
  }).isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    vat: PropTypes.number,
    // EURO CALCULATION
    totalPriceEuro: PropTypes.number,
    servicesFeesEuro: PropTypes.number,
    deliveryCostEuro: PropTypes.number,
    totalEuro: PropTypes.number,
    totToShowEuro: PropTypes.number,
    vatEuro: PropTypes.number,
  }).isRequired,
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateCart: PropTypes.func.isRequired,
  updateReservations: PropTypes.func.isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  history: PropTypes.any,
  customStyle: PropTypes.object,
  //
  cartUnique: PropTypes.arrayOf(PropTypes.any).isRequired,
};

Payment.defaultProps = {
  history: null,
  customStyle: {},
  cartUnique: [],
};

export default withRouter(Payment);
